import { render, staticRenderFns } from "./TestResult.vue?vue&type=template&id=478c582c&scoped=true"
import script from "./TestResult.vue?vue&type=script&lang=js"
export * from "./TestResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c582c",
  null
  
)

export default component.exports